import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from '@/components/ui/alert-dialog'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { Loader2, Trash2, CheckCircle2 } from 'lucide-react'

export const ActiveIntegration = ({ activeIntegration, selectedIntegrationId, setSelectedIntegrationId, getProviderDisplayName, disconnectCalendarMutation }: { activeIntegration: any, selectedIntegrationId: any, setSelectedIntegrationId: any, getProviderDisplayName: any, disconnectCalendarMutation: any }) => {
  return (
    <div className="p-6 border rounded-lg shadow-sm bg-white">
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
      <div>
        <h2 className="text-xl font-semibold text-gray-800">
          Active Calendar Integration
        </h2>
        <div className="flex items-center mt-2">
          <CheckCircle2 className="h-6 w-6 text-blue-600 mr-2" />
          <div>
            <p className="font-medium text-gray-700">
              {activeIntegration.account_email}
            </p>
            <Badge
              variant={
                activeIntegration.status.startsWith("active")
                  ? "default"
                  : "secondary"
              }
              className="text-xs"
            >
              {getProviderDisplayName(activeIntegration.provider)} -{" "}
              {activeIntegration.status
                .replace(/_/g, " ")
                .replace(/\b\w/g, (l: string) => l.toUpperCase())}
            </Badge>
          </div>
        </div>
      </div>
      <AlertDialog
        open={selectedIntegrationId === activeIntegration.id}
        onOpenChange={(open) =>
          !open && setSelectedIntegrationId(null)
        }
      >
        <AlertDialogTrigger asChild>
          <Button
            variant="destructive"
            className="mt-4 sm:mt-0 w-full sm:w-auto"
            onClick={() =>
              setSelectedIntegrationId(activeIntegration.id)
            }
            disabled={disconnectCalendarMutation.isPending}
          >
            {disconnectCalendarMutation.isPending ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Disconnecting...
              </>
            ) : (
              <>
                <Trash2 className="mr-2 h-4 w-4" />
                Disconnect Calendar
              </>
            )}
          </Button>
        </AlertDialogTrigger>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>
              Disconnect Calendar?
            </AlertDialogTitle>
            <AlertDialogDescription>
              Are you sure you want to disconnect your{" "}
              {getProviderDisplayName(activeIntegration.provider)}{" "}
              calendar ({activeIntegration.account_email})? This
              will stop all AI Employee activities related to this
              calendar. You can connect a new calendar afterwards.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction
              className="bg-red-600 hover:bg-red-700 text-white"
              onClick={() =>
                disconnectCalendarMutation.mutate(activeIntegration.id)
              }
              disabled={disconnectCalendarMutation.isPending}
            >
              {disconnectCalendarMutation.isPending
                ? "Disconnecting..."
                : "Yes, Disconnect"}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  </div>
  )
}